var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpense(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "var(--icon-bg-primary)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25436 12.5984L11.2557 7.66053L7.5599 7.63269C7.36117 7.61544 7.17843 7.52127 7.0482 7.36902C6.91797 7.21676 6.84984 7.01762 6.85743 6.8114C6.86502 6.60518 6.94776 6.40706 7.08913 6.25664C7.2305 6.10621 7.42008 6.01456 7.61999 6L13.2326 6.03788C13.2855 6.03798 13.338 6.04416 13.3891 6.05631C13.4118 6.06055 13.4341 6.0665 13.4558 6.07414L13.539 6.10365L13.6104 6.14467C13.6274 6.15949 13.6427 6.17609 13.6563 6.19421C13.7408 6.25451 13.8123 6.33174 13.8669 6.42148C13.8839 6.4363 13.8992 6.4529 13.9128 6.47102L13.9493 6.54655C13.9682 6.56695 13.964 6.60456 13.9742 6.63358C13.9806 6.65633 13.9854 6.67959 13.9885 6.70317C13.998 6.75647 14.0016 6.81089 13.9994 6.8654L13.7863 12.6551C13.7633 12.8606 13.6662 13.052 13.5143 13.1911C13.3624 13.3302 13.167 13.4067 12.9671 13.4054C12.7672 13.404 12.5775 13.3249 12.4359 13.1838C12.2944 13.0427 12.2114 12.8501 12.2035 12.6444L12.3356 8.82604L7.33427 13.764C7.17977 13.9165 6.9747 14.0014 6.76419 14C6.55367 13.9986 6.35495 13.9109 6.21175 13.7564C6.06854 13.6018 5.99258 13.393 6.00057 13.1758C6.00856 12.9587 6.09985 12.751 6.25436 12.5984Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpense);
export default __webpack_public_path__ + "static/media/expense.a062c305d8897cf4d0d7a28a8b416f8e.svg";
export { ForwardRef as ReactComponent };